import React from "react";

const TimeLineTarget = ({
  title,
  subtitle,
  icon,
  footer,
  starttarget,
  endtarget,
  color,
  openModal,
  duracionPromedio,
  tiempoEstimado,
  medida,
  active,
  value,
  setValue,
}) => {
  const getColorClass = (duracionPromedio, tiempoEstimado, medida) => {
    const diferencia = duracionPromedio - tiempoEstimado;

    if (medida === "D" || medida === "M") {
      if (duracionPromedio <= tiempoEstimado) {
        return "circulo-verde"
      } else if (diferencia >= 1 && diferencia < 2) {
        return "circulo-amarillo";
      } else {
        return "circulo-rojo";
      }
    } else if (medida === "H") {
      if (duracionPromedio <= tiempoEstimado) {
        return "circulo-verde";
      } else if (diferencia > 2 && diferencia <= 4) {
        return "circulo-amarillo";
      } else {
        return "circulo-rojo";
      }
    } else {
      return "";
    }
  };


  const colorClass = getColorClass(duracionPromedio, tiempoEstimado, medida);

  return (
    <div
      className={`${active === undefined ||
          active === null ||
          typeof active !== "boolean" ||
          active === false
          ? "analisis-sc-procesos-target"
          : "analisis-sc-procesos-target analisis-sc-procesos-target-active"
        }`}
    >
      {starttarget !== undefined && starttarget !== null && (
        <div className="analisis-sc-procesos-conector-start" />
      )}

      {(endtarget === undefined || endtarget === null) && (
        <div
          className={`analisis-sc-procesos-conector analisis-sc-procesos-conector-${color}`}
        />
      )}

      <div className="analisis-sc-procesos-target-title">{title}</div>
      <div className="analisis-sc-procesos-target-subtitle">{subtitle}</div>
      <div className="analisis-sc-procesos-target-icon">
        <div
          className={`analisis-sc-procesos-target-icon-circle analisis-sc-procesos-target-icon-circle ${colorClass}`}
        >
          {icon}
        </div>
      </div>
      <div className="analisis-sc-procesos-target-footer">
        <div>{footer.leyenda}</div>
        <div>{footer.tiempoestimado}</div>
        <div>{footer.duracion}</div>
        {/* <div>{footer.comentarios}</div> */}
      </div>
    </div>
  );
};

export default TimeLineTarget;
